<template>

    <a class="ad_menu-item ad_menu-item--my-account"
        :href="$config.ACCOUNT_URL"
        v-if="ready && isAuth">

        <i class="fa fa-user"></i>
        <span class="ad_menu-item__label">{{ utilisateur.email }}</span>

    </a>

</template>

<script>
import { mapState } from 'vuex'

import { useToken } from '@/helpers/auth'
import { actions as utilisateurActions } from '@/store/utilisateurs'

export default {

    data() {
        return {
            ready: false,
        }
    },

    computed: mapState({

        isAuth: state => ( state.utilisateurs.current !== null ),

        utilisateur: state => state.utilisateurs.current

    }),

    created() {

        /// Si l'utilisateur n'est pas authentifié,
        /// On ne charge rien
        if ( !useToken() ) {
            return
        }

        Promise.all([
            this.$store.dispatch(utilisateurActions.GET)
        ])
        .then( () => {
            this.ready = true
        })
    },

    name: 'MyAccountLink'
}
</script>
